module.exports = __webpack_public_path__ + "static/media/slayerage-logo.ecb36714.png";